import { render, staticRenderFns } from "./RefCheckboxes.vue?vue&type=template&id=aece7940&"
import script from "./RefCheckboxes.vue?vue&type=script&lang=js&"
export * from "./RefCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./RefCheckboxes.vue?vue&type=style&index=0&id=aece7940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports